import { asNumber } from "pdf-lib";
import React, { useCallback, useContext, useEffect, useState } from "react";
import Transaction from "../../API/APIServices/Transaction";
import Account from "../../API/APIServices/Account";
import LensItemCreation from "../../API/APIServices/LensItemCreation";
import ConvertInvoiceAndSynchDataController from "../../API/APIServices/ConvertInvoiceAndSynchDataController";
import MyContext from "../MyContext";
import Swal from "sweetalert2";
import AutoSuggestionBox from "../Components/AutoSuggestionBox";

const WorkshopModalLens = (props) => {
  const {
    closeWorkshopModal,
    WithFrameChange,
    TransId,
    SelectedItem,
    companies,
    setLoading,
  } = props;

  const { companyData, debounce } = useContext(MyContext);

  /********************Auto Suggestion*********************************************/

  const [isDropdownOpen1, setIsDropdownOpen1] = useState(false);

  const [filteredItems, setFilteredItems] = useState([]);
  const handleDataSelection = async (Data, index, Name) => {
    ;
    setWorkshopDetails((prevDetails) =>
      prevDetails.map((detail) => ({
        ...detail,
        op2: Data.name,
        op3: Data.id,
      }))
    );
  };

  const fetchdataSuggestions = async (name, value, GroupId, masterType) => {
    const filteredData = {
      MasterType: masterType,
      GroupWiseSuggestion: true,
      GroupId: GroupId,
      search_str: value,
      PageNumber: 1,
      PageSize: 500,
    };

    try {
      const SearchItem = await Account.GetAccountListForAutoSuggestion(
        filteredData
      );
      return SearchItem;
    } catch (error) {
      console.error("Error fetching account suggestions:", error);
      return null;
    }
  };

  const debouncedFetchDataSuggestions = useCallback(
    debounce(async (name, value, GroupId, masterType) => {
      const SearchItem = await fetchdataSuggestions(
        name,
        value,
        [],
        masterType
      );
      setIsDropdownOpen1(true);
      if (SearchItem) {
        setFilteredItems(SearchItem);
      }
    }, 500),
    []
  );

  const handleInputChangeAuto = (event, masterType) => {
    const { name, value } = event.target;

    debouncedFetchDataSuggestions(name, value, [], masterType);
  };

  /********************Auto Suggestion*********************************************/

  useEffect(() => {
    console.log("companies", companies);
    console.log("companyData", companyData);
  }, [companies, companyData]);

  const [lensDetail, setlensDetail] = useState([]);

  const GetlensDetail = async (id, LensOptionalData) => {
    try {
      const data = await Transaction.getSaleLensDataByTransId(id, 0);
      if (data) {
        ;
        setlensDetail(data || []);

        let workshopDetails = [];

        var filteredData = data;

        if (Array.isArray(filteredData) && filteredData.length > 0) {
          workshopDetails = filteredData.map((item) => ({
            id: 0,
            upsertId: Number(SelectedItem.TransId || SelectedItem.id) || "",
            workshopName: companyData.id,
            orderNo: item.vouchNo || "",
            partyName:
              item.partyName ||
              item.partyname ||
              SelectedItem.partyName ||
              SelectedItem.partyname ||
              "",
            partyId:
              item.partyId ||
              item.partyid ||
              SelectedItem.partyId ||
              SelectedItem.partyid,
            lItemName: item.lItemName || "",
            rItemName: item.rItemName || "",
            lItemId_d2: item.lItemId_d2 || "",
            rItemId_d2: item.rItemId_d2 || "",
            spH_R: item.rSphDv || "",
            spH_L: item.lSphDv || "",
            cyL_R: item.rCylDv || "",
            cyL_L: item.lCylDv || "",
            axiS_R: item.rAxisDv || "",
            axiS_L: item.lAxisDv || "",
            v_N_R: item.rVnDv || "",
            v_N_L: item.lVnDv || "",
            adD_R: item.rAdd || "",
            adD_L: item.lAdd || "",
            pD_R: item.pdr || "",
            pD_L: item.pdl || "",
            lensDetail:
              LensOptionalData.length == 0 ? "" : LensOptionalData || "",
          }));
        } else {
          workshopDetails = [
            {
              id: 0,
              upsertId: Number(SelectedItem.TransId || SelectedItem.id) || "",
              workshopName: companyData.id,
              orderNo: "",
              partyName: "",
              partyId: SelectedItem.partyId || SelectedItem.partyid,
              lItemName: "",
              rItemName: "",
              lItemId_d2: "",
              rItemId_d2: "",
              spH_R: "",
              spH_L: "",
              cyL_R: "",
              cyL_L: "",
              axiS_R: "",
              axiS_L: "",
              v_N_R: "",
              v_N_L: "",
              adD_R: "",
              adD_L: "",
              pD_R: "",
              pD_L: "",
              lensDetail:
                LensOptionalData.length == 0 ? "" : LensOptionalData || "",
            },
          ];
          Swal.fire({
            icon: "warning",
            title: "No lens found for this transaction.",
            text: "",
            timer: 2000,
            showConfirmButton: false,
            timerProgressBar: true,
            width: "250px",
            customClass: {
              title: "swal2-custom-title",    confirmButton: 'my-confirm-button',
    cancelButton: 'my-cancel-button' ,

              popup: "swal2-custom-popup",
              htmlContainer: "swal2-custom-text",
              icon: "swal2-custom-icon",
            },
          });
          closeWorkshopModal();
        }
        setWorkshopDetails(workshopDetails);
        return data.length;
      } else {
        return data.length;
      }
    } catch (error) {
      console.error("Error fetching lens details:", error);
      alert("Error while fetching data");
    }
  };

  useEffect(() => {
    const getOptionalFields = async (masterType) => {
      var LensOptionalData = await LensItemCreation.GetLensPowerOptionalField(
        masterType
      );
      if (LensOptionalData) {
        setLensOptionalField(LensOptionalData);
        setTimeout(async () => {
          var isDataInWorkShop = await GetTransWorkShopDetailByID(
            SelectedItem.TransId || SelectedItem.id,
            LensOptionalData
          );
          ;
          if (isDataInWorkShop == 0) {
            GetlensDetail(
              SelectedItem.TransId || SelectedItem.id,
              LensOptionalData
            );
          }
        }, 10);
      } else {
        setTimeout(async () => {
          var isDataInWorkShop = await GetTransWorkShopDetailByID(
            SelectedItem.TransId || SelectedItem.id,
            LensOptionalData
          );
          ;
          if (isDataInWorkShop == 0) {
            GetlensDetail(
              SelectedItem.TransId || SelectedItem.id,
              LensOptionalData
            );
          }
        }, 10);
      }
    };
    getOptionalFields(7);
  }, [TransId]);

  const GetTransWorkShopDetailByID = async (id, LensOptionalData) => {
    try {
      ;
      const response = await Transaction.GetAllTransWorkShopDetail(id);
      if (response) {
        let workshopDetails = [];
        var filteredData = response.result;
        if (Array.isArray(filteredData) && filteredData.length > 0) {
          workshopDetails = filteredData.map((item) => ({
            id: item.id,
            upsertId: item.upsertId || "",
            workshopName: item.workshopName
              ? item.workshopName
              : companyData.id,
            orderNo: item.orderNo || "",
            partyName: item.partyName || "",
            partyId: item.partyId,
            lItemName: item.lItemName || "",
            rItemName: item.rItemName || "",
            lItemId_d2: item.lItemId_d2 || "",
            rItemId_d2: item.rItemId_d2 || "",
            spH_R: item.spH_R || "",
            spH_L: item.spH_L || "",
            cyL_R: item.cyL_R || "",
            cyL_L: item.cyL_L || "",
            axiS_R: item.axiS_R || "",
            axiS_L: item.axiS_L || "",
            v_N_R: item.v_N_R || "",
            v_N_L: item.v_N_L || "",
            adD_R: item.adD_R || "",
            adD_L: item.adD_L || "",
            pD_R: item.pD_R || "",
            pD_L: item.pD_L || "",
            op2: item.op2,
            op3: item.op3,
            lensDetail: item.lensDetail
              ? JSON.parse(item.lensDetail).map((field) => {
                  const key = Object.keys(field)[0];
                  return {
                    masterType: 7,
                    optionalFieldName: key,
                    ef1: field[key], // Value goes here
                    ef2: null,
                    ef3: null,
                    isDeleted: false,
                    isActive: true,
                  };
                })
              : LensOptionalData,
          }));
        } else {
          workshopDetails = [
            {
              id: 0,
              upsertId: Number(SelectedItem.TransId || SelectedItem.id) || "",
              workshopName: "",
              orderNo: "",
              partyName: "",
              partyId: SelectedItem.partyId || SelectedItem.partyid,
              lItemName: "",
              rItemName: "",
              lItemId_d2: "",
              rItemId_d2: "",
              spH_R: "",
              spH_L: "",
              cyL_R: "",
              cyL_L: "",
              axiS_R: "",
              axiS_L: "",
              v_N_R: "",
              v_N_L: "",
              adD_R: "",
              adD_L: "",
              pD_R: "",
              pD_L: "",
              op2: "",
              op3: "",
              lensDetail: LensOptionalData,
              trans1Id: Number(SelectedItem.TransId || SelectedItem.id),
            },
          ];
        }
        setWorkshopDetails(workshopDetails);

        return response.result.length;
      } else {
        return response.result.length;
      }
    } catch (error) {
      console.error(error);
    }
  };

  console.log("SelectedItem", SelectedItem);
  console.log("companies", companies);

  const [workshopDetails, setWorkshopDetails] = useState([
    {
      id: 0,
      upsertId: Number(SelectedItem.TransId || SelectedItem.id) || "",
      workshopName: companyData.id,
      orderNo: SelectedItem.vouchNo || "",
      partyName: SelectedItem.partyName || SelectedItem.partyname || "",
      partyId: SelectedItem.partyId || SelectedItem.partyid,
      // partyId: "",
      lItemName: "",
      rItemName: "",
      lItemId_d2: "",
      rItemId_d2: "",
      spH_R: "",
      spH_L: "",
      cyL_R: "",
      cyL_L: "",
      axiS_R: "",
      axiS_L: "",
      v_N_R: "",
      v_N_L: "",
      adD_R: "",
      adD_L: "",
      pD_R: "",
      pD_L: "",
      lensDetail: "",
      trans1Id: Number(SelectedItem.TransId || SelectedItem.id),
      op2: "", //VendorName
      op3: "", // Vendorid
    },
  ]);

  const [LensOptionalField, setLensOptionalField] = useState([]);

  console.log("LensOptionalField", LensOptionalField);
  console.log("workshopDetails", workshopDetails);

  // const AddRowInWorkshopDetails = () => {
  //   setWorkshopDetails((prevValues) => [
  //     ...prevValues,
  //     {
  //       id: 0,
  //       upsertId: Number(SelectedItem.TransId || SelectedItem.id) || "",
  //       workshopName: 0,
  //       orderNo: "",
  //       partyName: "",
  //       ItemName: "",
  //       spH_R: "",
  //       spH_L: "",
  //       cyL_R: "",
  //       cyL_L: "",
  //       axiS_R: "",
  //       axiS_L: "",
  //       v_N_R: "",
  //       v_N_L: "",
  //       adD_R: "",
  //       adD_L: "",
  //       pD_R: "",
  //       pD_L: "",
  //       customerCard: "",
  //       dia: "",
  //       fittingHeight: "",
  //       fittingType: "",
  //       diM_R: "",
  //       diM_L: "",
  //       base: "",
  //       prismRemarks: "",
  //       tint: "",
  //       fitting: "",
  //       mirror: "",
  //       remarks: "",
  //       withFrame: "",
  //       lensOnly: "",
  //       trans1Id: Number(SelectedItem.TransId || SelectedItem.id),
  //     },
  //   ]);
  // };

  const DeleteRowInWorkshopDetails = (index) => {
    if (workshopDetails.length > 1) {
      // Only delete if there's more than one row
      setWorkshopDetails((prevValues) =>
        prevValues.filter((_, i) => i !== index)
      );
    } else {
      console.log("Cannot delete the last row.");
    }
  };

  const handleInputChange = (event, index) => {
    const { name, value } = event.target;
    console.log(`Changing ${name} to ${value} at index ${index}`);
    setWorkshopDetails((prevValues) => {
      const updatedValues = [...prevValues]; // Create a shallow copy of the array
      updatedValues[index] = {
        ...updatedValues[index], // Create a copy of the object at the specific index
        [name]: value, // Update the specific property
      };
      return updatedValues; // Return the updated array
    });
  };

  const handleExtrafieldChange = (e, lensIndex, itemIndex) => {
    const { value } = e.target;

    setWorkshopDetails((prev) => {
      // Clone the full list
      const newItemsList = [...prev];

      // Clone the item at the given index
      const updatedItem = { ...newItemsList[itemIndex] };

      // Parse lensDetail if it's a string (like in id 1070)
      let lensDetail = updatedItem.lensDetail;
      if (typeof lensDetail === "string") {
        try {
          lensDetail = JSON.parse(lensDetail);
        } catch {
          lensDetail = [];
        }
      }

      // Clone lensDetail array and update ef1 at lensIndex
      const newLensDetail = [...lensDetail];
      const updatedLens = { ...newLensDetail[lensIndex], ef1: value };
      newLensDetail[lensIndex] = updatedLens;

      // Set updated lensDetail
      updatedItem.lensDetail = newLensDetail;

      // Replace the item back into the list
      newItemsList[itemIndex] = updatedItem;

      return newItemsList;
    });
  };

  const CreateTransaction = async (TransName) => {
    ;

    var partyId = 214;
    console.log("lensDetail", lensDetail);

    try {
      setLoading(true);
      var ReferenceNumber = "";
      var TransType = TransName === "sale" ? 71 : 70;
      var convertType = TransName === "sale" ? 5 : 2;
      var transId = Number(SelectedItem.TransId || SelectedItem.id);
      var ToBranchId = [companyData.id];

      if (TransName === "sale") {
        const hasMatchingCompany = workshopDetails.some(
          (company) => company.workshopName == companyData.id
        );
        if (hasMatchingCompany) {
          Swal.fire({
            icon: "warning",
            title: "Invalid Selection",
            text: "Please select a different company to create the Sale Order. You have selected the company you are currently logged in to.",
          });
          return;
        }
        if (convertType == 5) {
          ToBranchId = workshopDetails.map((x) => x.workshopName);
        }
      }

      var RefNoData = await Transaction.GetTransRefNo(TransType);
      if (RefNoData.isSuccess === true) {
        ReferenceNumber = RefNoData.result.referenceNumber;
      } else {
        alert("Error while getting Transaction Reference No.");
        return;
      }

      const conversionResults = await Promise.all(
        ToBranchId.map((element) =>
          ConvertInvoiceAndSynchDataController.SendTransDataToConvert(
            ReferenceNumber,
            transId,
            companyData.id, // from branch id
            element, // to branch id
            convertType,
            TransType // Trans Type for conversion (e.g., 12 for Sale)
          )
        )
      );

      const allSuccessful = conversionResults.every(
        (result) => result?.isSuccess === true
      );

      if (allSuccessful) {
        setLoading(false);
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Created Successfully",
          customClass: {
            title: "swal2-custom-title",    confirmButton: 'my-confirm-button',
    cancelButton: 'my-cancel-button' ,

            popup: "swal2-custom-popup",
            htmlContainer: "swal2-custom-text",
            icon: "swal2-custom-icon",
          },
          confirmButtonText: "OK",
        });
      } else {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Partial Failure",
          text: "Some conversions failed. Please check the logs.",
        });
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An error occurred during conversion.",
      });
    } finally {
      setLoading(false);
    }

    /****************************Auto Suggestion********************************/

    /****************************Auto Suggestion********************************/

    // try {
    //   ToBranchId.forEach(element => {

    //     const conversionData =
    //       await ConvertInvoiceAndSynchDataController.SendTransDataToConvert(
    //         ReferenceNumber,
    //         transId,
    //         companyData.id, //from branch id DBIdT1
    //         // companyData.id, //to branch id
    //         element, //to branch id
    //         convertType,
    //         TransType // Trans Type To which conversion is going to be done ForEx (12 For Sale)
    //       );
    //   });
    //   if (conversionData.isSuccess === true) {
    //     setLoading(false);
    //     Swal.fire({
    //       icon: "success",
    //       title: "Success",
    //       text: "Created Successfully",
    //       customClass: {
    //         title: "swal2-custom-title",    confirmButton: 'my-confirm-button',
    // cancelButton: 'my-cancel-button' ,

    //         popup: "swal2-custom-popup",
    //         htmlContainer: "swal2-custom-text",
    //         icon: "swal2-custom-icon",
    //       },
    //       confirmButtonText: "OK",
    //     });
    //   }
    // } catch (error) {
    //   console.error(error);
    // } finally {
    //   setLoading(false);
    // }

    // var BillData = {
    //   TransType: TransName === "sale" ? 12 : 14,
    //   transId: 0,
    //   TransName: TransName === "sale" ? "sale" : "Purchase",
    //   billSeriesMasterType: 29,
    //   billSeriesId: 0,
    //   billSeriesName: "",
    //   billTaxTypeId: 0,
    //   billTaxTypeName: "",
    //   billDate: new Date().toISOString().split("T")[0],
    //   billNumber: "",
    //   godownId: 0,
    //   godownName: "",
    //   bookedById: 0,
    //   bookedByName: "",
    //   DeliveryDate: "",
    //   vochStatusId: 931,
    //   vochStatusName: "",
    //   billDeliveryDate: "",
    //   refBillNumber: "",
    //   ShortNarration: "",
    //   Remark: "",
    //   Remark1: "",
    //   Remark2: "",
    //   Remark3: "",
    //   TotalQty: 0,
    //   TotalPrice: 0,
    //   TotalDisc: 0,
    //   TotalItemAmt: 0,
    //   TotalMrp: 0,
    //   TotalSundry: 0,
    //   LoyalityAmt: 0,
    //   CouponAmt: 0,
    //   TaxableAmt: 0,
    //   GrossAmt: 0,
    //   PaidAmt: 0,
    //   DueAmt: 0,
    //   AdjstAmt: 0,
    //   isActive: true,
    //   isDefault: false,
    //   paymentStatus: "",
    //   isEcomInvoice: "",
    //   ecomDelAddress: "",
    //   ecomBillAddress: "",
    //   ecomDelContact: "",
    // };

    // var data = await Account.getAccountById(partyId);
    // ;
    // var AccData = data.item1[0];
    // var AccDataNew = {
    //   AccId: AccData.d2Id || 214,
    //   namePrefix: "",
    //   AccName: AccData.name || "CASH",
    //   AccPhoneNo: "",
    //   AccDob: AccData.dob || "",
    //   AccAnn: AccData.dom || "",
    //   AccPOS: AccData.stateId || "",
    //   AccBalance: "",
    //   AccCreditLimit: AccData.creditlimit || "",
    //   AccAddress: AccData.address || "",
    //   AccStateId: AccData.stateId || "",
    //   AccState: AccData.stateName || "",
    //   AccRefById: 0,
    //   AccRefferedBy: "",
    //   // parentGrp: 212,
    //   AccEmail: AccData.email || "",
    // };

    // if (
    //   AccDataNew.AccId &&
    //   AccDataNew.AccId != 0 &&
    //   ReferenceNumber != "" &&
    //   ReferenceNumber != null
    // ) {
    //   try {
    //     // Attempt to save the transaction bill data
    //     const TransBillData = await Transaction.SetTransBillData(
    //       BillData,
    //       AccDataNew,
    //       ReferenceNumber
    //     );
    //     if (TransBillData.isSuccess === true) {
    //       // alert("Transaction bill data saved successfully");
    //       setProductData(ReferenceNumber, TransName);
    //     }
    //   } catch (error) {
    //     console.error(
    //       "Error occurred while saving the transaction bill data:",
    //       error
    //     );
    //   }
    // }
  };

  const setProductData = async (ReferenceNumber, TransName) => {
    ;
    var ProductData = [];
    for (let i = 0; i < lensDetail.length; i++) {
      const item = lensDetail[i];
      const filterData = {
        searchTypeId: 5,
        itmId_d2: item.rItemId_d2,
      };

      if (item.rAxisDv !== undefined && item.rAxisDv !== null) {
        filterData.axis = Number(item.rAxisDv);
      }

      if (
        item.rAdd !== undefined &&
        item.rAdd !== null &&
        Number(item.rAdd) !== 0
      ) {
        filterData.add = Number(item.lens_Add);
      }

      if (item.rCylDv !== undefined && item.rCylDv !== null) {
        filterData.cyl = Number(item.rCylDv);
      }

      if (item.rSphDv !== undefined && item.rSphDv !== null) {
        filterData.sph = Number(item.rSphDv);
      }

      const ItemDataR = await Transaction.GetBarcodeSerialBatchNoForItemFetch(
        filterData
      );

      if (ItemDataR && Object.keys(ItemDataR).length > 0) {
        const RItemData = {
          d1_Id: ItemDataR.d1_Id || "",
          d2_Id: ItemDataR.d2_Id || "",
          productName: ItemDataR.productName || "",
          parentGrp: ItemDataR.parentGrp2 || "",
          parentGrpName: ItemDataR.parentGrpName || "",
          productUnitName: ItemDataR.productUnitName || "",
          productUnit: ItemDataR.productUnit || "",
          productAltUnit: ItemDataR.productAltUnit || "",
          unitConvFactor: ItemDataR.unitConvFactor || "",
          enableBarcode: ItemDataR.enableBarcode || "",
          defaultBarcode: ItemDataR.Barcode || "",
          batchNos: ItemDataR.batchDetails || [],
          taxCategory1: ItemDataR.taxCategory1 || "",
          taxLimit: ItemDataR.taxLimit || "",
          taxCategory2: ItemDataR.taxCategory2 || "",
          hsnCode: ItemDataR.hsnCode || "",
          shortDescription: "",
          Qty: ItemDataR.Qty === 0 ? 1 : ItemDataR.Qty || 1,
          FreeQty: ItemDataR.FreeQty || "",
          purchasePrice: ItemDataR.purchasePrice || "",
          purchaseDiscount: ItemDataR.purchaseDiscount || "",
          saleProfit: ItemDataR.saleProfit || "",
          salePrice: ItemDataR.salePrice || "",
          saleDiscount: ItemDataR.saleDiscount || "",
          itemPrice:
            TransName === "sale"
              ? ItemDataR.salePrice
              : TransName === "Purchase"
              ? ItemDataR.purchasePrice
              : ItemDataR.salePrice,

          costPrice: ItemDataR.costPrice || "",
          mrpPrice: ItemDataR.mrpPrice || "",
          DiscPer:
            TransName === "sale"
              ? ItemDataR.saleDiscount
              : TransName === "Purchase"
              ? ItemDataR.purchaseDiscount
              : ItemDataR.saleDiscount,
          DiscAmt: ItemDataR.DiscAmt || "",
          TotalAmt: ItemDataR.TotalAmt || "",
          // salePriceForPur: ItemDataR.salePriceForPur || 0,
          purPageSalePrice: ItemDataR.salePrice || "",
          availableQuantity: ItemDataR.availableQuantity || "",
          lens_Eye: ItemDataR.lens_Eye || "",
          lens_SPH: ItemDataR.lens_SPH.toFixed(2) || "",
          lens_CYL: ItemDataR.lens_CYL.toFixed(2) || "",
          lens_AXIS: ItemDataR.lens_AXIS || "",
          lens_Dia: ItemDataR.lens_Dia || "",
          lens_Add: ItemDataR.lens_Add?.toFixed(2) || "",
          enableSerialNo: ItemDataR.enableSerialNo || "",
          taxCat1_Cgst: ItemDataR.taxCat1_Cgst || "",
          taxCat1_Sgst: ItemDataR.taxCat1_Sgst || "",
          taxCat1_Igst: ItemDataR.taxCat1_Igst || "",
          taxCat1_Cess: ItemDataR.taxCat1_Cess || "",
          taxLimit: ItemDataR.taxLimit || "",
          taxCategory2: ItemDataR.taxCategory2 || "",
          taxCat2_Cgst: ItemDataR.taxCat2_Cgst || "",
          taxCat2_Sgst: ItemDataR.taxCat2_Sgst || "",
          taxCat2_Igst: ItemDataR.taxCat2_Igst || "",
          taxCat2_Cess: ItemDataR.taxCat2_Cess || "",
          LensTypeEf: ItemDataR.LensTypeEf || "",
        };
        ProductData.push(RItemData);
      } else {
        const filterData = {
          searchTypeId: 4,
          itmId_d2: item.rItemId_d2,
        };
        const ItemDataR = await Transaction.GetBarcodeSerialBatchNoForItemFetch(
          filterData
        );
        const RItemData = {
          d1_Id: ItemDataR.d1_Id || "",
          d2_Id: ItemDataR.d2_Id || "",
          productName: ItemDataR.productName || "",
          parentGrp: ItemDataR.parentGrp2 || "",
          parentGrpName: ItemDataR.parentGrpName || "",
          productUnitName: ItemDataR.productUnitName || "",
          productUnit: ItemDataR.productUnit || "",
          productAltUnit: ItemDataR.productAltUnit || "",
          unitConvFactor: ItemDataR.unitConvFactor || "",
          enableBarcode: ItemDataR.enableBarcode || "",
          defaultBarcode: ItemDataR.Barcode || "",
          batchNos: ItemDataR.batchDetails || [],
          taxCategory1: ItemDataR.taxCategory1 || "",
          taxLimit: ItemDataR.taxLimit || "",
          taxCategory2: ItemDataR.taxCategory2 || "",
          hsnCode: ItemDataR.hsnCode || "",
          shortDescription: "",
          Qty: ItemDataR.Qty === 0 ? 1 : ItemDataR.Qty || 1,
          FreeQty: ItemDataR.FreeQty || "",
          purchasePrice: ItemDataR.purchasePrice || "",
          purchaseDiscount: ItemDataR.purchaseDiscount || "",
          saleProfit: ItemDataR.saleProfit || "",
          salePrice: ItemDataR.salePrice || "",
          saleDiscount: ItemDataR.saleDiscount || "",
          itemPrice:
            TransName === "sale"
              ? ItemDataR.salePrice
              : TransName === "Purchase"
              ? ItemDataR.purchasePrice
              : ItemDataR.salePrice,

          costPrice: ItemDataR.costPrice || "",
          mrpPrice: ItemDataR.mrpPrice || "",
          DiscPer:
            TransName === "sale"
              ? ItemDataR.saleDiscount
              : TransName === "Purchase"
              ? ItemDataR.purchaseDiscount
              : ItemDataR.saleDiscount,
          DiscAmt: ItemDataR.DiscAmt || "",
          TotalAmt: ItemDataR.TotalAmt || "",
          // salePriceForPur: ItemDataR.salePriceForPur || 0,
          purPageSalePrice: ItemDataR.salePrice || "",
          availableQuantity: ItemDataR.availableQuantity || "",
          lens_Eye: ItemDataR.lens_Eye || "",
          lens_SPH: ItemDataR.lens_SPH.toFixed(2) || "",
          lens_CYL: ItemDataR.lens_CYL.toFixed(2) || "",
          lens_AXIS: ItemDataR.lens_AXIS || "",
          lens_Dia: ItemDataR.lens_Dia || "",
          lens_Add: ItemDataR.lens_Add?.toFixed(2) || "",
          enableSerialNo: ItemDataR.enableSerialNo || "",
          taxCat1_Cgst: ItemDataR.taxCat1_Cgst || "",
          taxCat1_Sgst: ItemDataR.taxCat1_Sgst || "",
          taxCat1_Igst: ItemDataR.taxCat1_Igst || "",
          taxCat1_Cess: ItemDataR.taxCat1_Cess || "",
          taxLimit: ItemDataR.taxLimit || "",
          taxCategory2: ItemDataR.taxCategory2 || "",
          taxCat2_Cgst: ItemDataR.taxCat2_Cgst || "",
          taxCat2_Sgst: ItemDataR.taxCat2_Sgst || "",
          taxCat2_Igst: ItemDataR.taxCat2_Igst || "",
          taxCat2_Cess: ItemDataR.taxCat2_Cess || "",
          LensTypeEf: ItemDataR.LensTypeEf || "",
        };
        ProductData.push(RItemData);
      }

      const filterData1 = {
        searchTypeId: 5,
        itmId_d2: item.lItemId_d2,
      };

      if (item.lAxisDv !== undefined && item.lAxisDv !== null) {
        filterData1.axis = Number(item.lAxisDv);
      }

      if (
        item.lAdd !== undefined &&
        item.lAdd !== null &&
        Number(item.lAdd) !== 0
      ) {
        filterData1.add = Number(item.lAdd);
      }

      if (item.lCylDv !== undefined && item.lCylDv !== null) {
        filterData1.cyl = Number(item.lCylDv);
      }

      if (item.lSphDv !== undefined && item.lSphDv !== null) {
        filterData1.sph = Number(item.lSphDv);
      }

      const ItemDataL = await Transaction.GetBarcodeSerialBatchNoForItemFetch(
        filterData1
      );

      if (ItemDataL && Object.keys(ItemDataL).length > 0) {
        const LItemData = {
          d1_Id: ItemDataL.d1_Id || "",
          d2_Id: ItemDataL.d2_Id || "",
          productName: ItemDataL.productName || "",
          parentGrp: ItemDataL.parentGrp2 || "",
          parentGrpName: ItemDataL.parentGrpName || "",
          productUnitName: ItemDataL.productUnitName || "",
          productUnit: ItemDataL.productUnit || "",
          productAltUnit: ItemDataL.productAltUnit || "",
          unitConvFactor: ItemDataL.unitConvFactor || "",
          enableBarcode: ItemDataL.enableBarcode || "",
          defaultBarcode: ItemDataL.Barcode || "",
          batchNos: ItemDataL.batchDetails || [],
          taxCategory1: ItemDataL.taxCategory1 || "",
          taxLimit: ItemDataL.taxLimit || "",
          taxCategory2: ItemDataL.taxCategory2 || "",
          hsnCode: ItemDataL.hsnCode || "",
          shortDescription: "",
          Qty: ItemDataL.Qty === 0 ? 1 : ItemDataL.Qty || 1,
          FreeQty: ItemDataL.FreeQty || "",
          purchasePrice: ItemDataL.purchasePrice || "",
          purchaseDiscount: ItemDataL.purchaseDiscount || "",
          saleProfit: ItemDataL.saleProfit || "",
          salePrice: ItemDataL.salePrice || "",
          saleDiscount: ItemDataL.saleDiscount || "",
          itemPrice:
            TransName === "sale"
              ? ItemDataL.salePrice
              : TransName === "Purchase"
              ? ItemDataL.purchasePrice
              : ItemDataL.salePrice,

          costPrice: ItemDataL.costPrice || "",
          mrpPrice: ItemDataL.mrpPrice || "",
          DiscPer:
            TransName === "sale"
              ? ItemDataL.saleDiscount
              : TransName === "Purchase"
              ? ItemDataL.purchaseDiscount
              : ItemDataL.saleDiscount,
          DiscAmt: ItemDataL.DiscAmt || "",
          TotalAmt: ItemDataL.TotalAmt || "",
          // salePriceForPur: ItemDataL.salePriceForPur || 0,
          purPageSalePrice: ItemDataL.salePrice || "",
          availableQuantity: ItemDataL.availableQuantity || "",
          lens_Eye: ItemDataL.lens_Eye || "",
          lens_SPH: ItemDataL.lens_SPH.toFixed(2) || "",
          lens_CYL: ItemDataL.lens_CYL.toFixed(2) || "",
          lens_AXIS: ItemDataL.lens_AXIS || "",
          lens_Dia: ItemDataL.lens_Dia || "",
          lens_Add: ItemDataL.lens_Add?.toFixed(2) || "",
          enableSerialNo: ItemDataL.enableSerialNo || "",
          taxCat1_Cgst: ItemDataL.taxCat1_Cgst || "",
          taxCat1_Sgst: ItemDataL.taxCat1_Sgst || "",
          taxCat1_Igst: ItemDataL.taxCat1_Igst || "",
          taxCat1_Cess: ItemDataL.taxCat1_Cess || "",
          taxLimit: ItemDataL.taxLimit || "",
          taxCategory2: ItemDataL.taxCategory2 || "",
          taxCat2_Cgst: ItemDataL.taxCat2_Cgst || "",
          taxCat2_Sgst: ItemDataL.taxCat2_Sgst || "",
          taxCat2_Igst: ItemDataL.taxCat2_Igst || "",
          taxCat2_Cess: ItemDataL.taxCat2_Cess || "",
          LensTypeEf: ItemDataL.LensTypeEf || "",
        };
        ProductData.push(LItemData);
      } else {
        const filterData1 = {
          searchTypeId: 4,
          itmId_d2: item.lItemId_d2,
        };
        const ItemDataL = await Transaction.GetBarcodeSerialBatchNoForItemFetch(
          filterData1
        );
        const LItemData = {
          d1_Id: ItemDataL.d1_Id || "",
          d2_Id: ItemDataL.d2_Id || "",
          productName: ItemDataL.productName || "",
          parentGrp: ItemDataL.parentGrp2 || "",
          parentGrpName: ItemDataL.parentGrpName || "",
          productUnitName: ItemDataL.productUnitName || "",
          productUnit: ItemDataL.productUnit || "",
          productAltUnit: ItemDataL.productAltUnit || "",
          unitConvFactor: ItemDataL.unitConvFactor || "",
          enableBarcode: ItemDataL.enableBarcode || "",
          defaultBarcode: ItemDataL.Barcode || "",
          batchNos: ItemDataL.batchDetails || [],
          taxCategory1: ItemDataL.taxCategory1 || "",
          taxLimit: ItemDataL.taxLimit || "",
          taxCategory2: ItemDataL.taxCategory2 || "",
          hsnCode: ItemDataL.hsnCode || "",
          shortDescription: "",
          Qty: ItemDataL.Qty === 0 ? 1 : ItemDataL.Qty || 1,
          FreeQty: ItemDataL.FreeQty || "",
          purchasePrice: ItemDataL.purchasePrice || "",
          purchaseDiscount: ItemDataL.purchaseDiscount || "",
          saleProfit: ItemDataL.saleProfit || "",
          salePrice: ItemDataL.salePrice || "",
          saleDiscount: ItemDataL.saleDiscount || "",
          itemPrice:
            TransName === "sale"
              ? ItemDataL.salePrice
              : TransName === "Purchase"
              ? ItemDataL.purchasePrice
              : ItemDataL.salePrice,

          costPrice: ItemDataL.costPrice || "",
          mrpPrice: ItemDataL.mrpPrice || "",
          DiscPer:
            TransName === "sale"
              ? ItemDataL.saleDiscount
              : TransName === "Purchase"
              ? ItemDataL.purchaseDiscount
              : ItemDataL.saleDiscount,
          DiscAmt: ItemDataL.DiscAmt || "",
          TotalAmt: ItemDataL.TotalAmt || "",
          // salePriceForPur: ItemDataL.salePriceForPur || 0,
          purPageSalePrice: ItemDataL.salePrice || "",
          availableQuantity: ItemDataL.availableQuantity || "",
          lens_Eye: ItemDataL.lens_Eye || "",
          lens_SPH: ItemDataL.lens_SPH.toFixed(2) || "",
          lens_CYL: ItemDataL.lens_CYL.toFixed(2) || "",
          lens_AXIS: ItemDataL.lens_AXIS || "",
          lens_Dia: ItemDataL.lens_Dia || "",
          lens_Add: ItemDataL.lens_Add?.toFixed(2) || "",
          enableSerialNo: ItemDataL.enableSerialNo || "",
          taxCat1_Cgst: ItemDataL.taxCat1_Cgst || "",
          taxCat1_Sgst: ItemDataL.taxCat1_Sgst || "",
          taxCat1_Igst: ItemDataL.taxCat1_Igst || "",
          taxCat1_Cess: ItemDataL.taxCat1_Cess || "",
          taxLimit: ItemDataL.taxLimit || "",
          taxCategory2: ItemDataL.taxCategory2 || "",
          taxCat2_Cgst: ItemDataL.taxCat2_Cgst || "",
          taxCat2_Sgst: ItemDataL.taxCat2_Sgst || "",
          taxCat2_Igst: ItemDataL.taxCat2_Igst || "",
          taxCat2_Cess: ItemDataL.taxCat2_Cess || "",
          LensTypeEf: ItemDataL.LensTypeEf || "",
        };
        ProductData.push(LItemData);
      }
    }

    if (ProductData.length > 0) {
      var ProductTempData = await Transaction.SetProductTempDataForMultiple(
        ProductData,
        ReferenceNumber
      );
      if (ProductTempData.isSuccess === true) {
        let transactionStatus;
        const TransBillData = await Transaction.SaveTransactions(
          ReferenceNumber
        );
        if (TransBillData.isSuccess === true) {
          let transactionfound = false;
          // setLoading(true);
          for (let i = 0; i < 60; i++) {
            transactionStatus = await Transaction.TransactionsStatus(
              ReferenceNumber
            );
            if (transactionStatus.isSuccess === true) {
              transactionfound = true;
              if (
                transactionStatus.result.status === 3 ||
                transactionStatus.result.status === 2
              ) {
                break;
              }
            } else {
              await sleep(500);
            }
          }
          if (!transactionfound) {
            console.log("Error in changing transaction status");
            setLoading(false);
            return;
          }
          if (transactionStatus.result.status === 3) {
            alert("Transaction Failed");
            setLoading(false);
          } else if (transactionStatus.result.status === 2) {
            alert("Transaction Success");
            // setLoading(false);
          } else {
            alert("Transaction Failed");
            setLoading(false);
          }
        } else {
          alert("Error in Trans Bill Data");
          setLoading(false);
        }

        setLoading(false);
      } else {
        alert("Error in Product Temp Data");
        setLoading(false);
      }
    } else {
      alert("Error while fetching data");
      setLoading(false);
    }
  };

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function transformLensDetails(data) {
    return data.map((item) => {
      const lensDetailArray = [];

      if (Array.isArray(item.lensDetail)) {
        item.lensDetail.forEach((detail) => {
          if (detail.isActive && !detail.isDeleted) {
            lensDetailArray.push({ [detail.optionalFieldName]: detail.ef1 });
          }
        });
      }

      return {
        ...item,
        lensDetail: JSON.stringify(lensDetailArray),
      };
    });
  }

  const SaveAndUpdateWorkshopData = async () => {
    ;
    if (!workshopDetails[0].op3) {
      Swal.fire({
        icon: "warning",
        title: "Vendor Not Selected",
        text: "Please select a vendor before proceeding.",
        confirmButtonText: "OK",
      });
      return;
    }

    const transformedData = transformLensDetails(workshopDetails);
    console.log(transformedData);
    ;
    const SaveData = await Transaction.CreateOrUpdateWorkshopDetail(
      transformedData
    );

    if (SaveData.isSuccess) {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Workshop Saved Successfully",
        timer: 2000,
        showConfirmButton: false,
        timerProgressBar: true,
        width: "250px",
        customClass: {
          title: "swal2-custom-title",    confirmButton: 'my-confirm-button',
    cancelButton: 'my-cancel-button' ,

          popup: "swal2-custom-popup",
          htmlContainer: "swal2-custom-text",
          icon: "swal2-custom-icon",
        },
      });
      closeWorkshopModal();
    } else {
      alert("Error while saving data");
    }
  };

  return (
    <div className="modal-back">
      <div
        className="partyDetail-modal"
        style={{ height: "auto", backgroundColor: "white", width: "40%" }}
      >
        <div style={{ padding: "15px" }}>
          <div className="ws-heading">
            <label>Workshop Details</label>
            <label
              style={{ cursor: "pointer", fontSize: "24px" }}
              onClick={closeWorkshopModal}
            >
              x
            </label>
          </div>

          <div
            className="overflowY"
            style={{
              height: "auto",
              maxHeight: "500px",
              padding: "7px",
              border: "none",
              textAlign: "center",
            }}
          >
            {workshopDetails.map((Item, index) => (
              <div
                style={{
                  position: "relative",
                  border: "1px solid #cacaca",
                  padding: "10px",
                  borderRadius: "8px",
                  marginBottom: "15px",
                  boxShadow: "#c1c1c1 3px 4px 8px",
                }}
              >
                <div></div>
                <div className="space-between">
                  <span
                    className="DeleteWorkShoputton"
                    type="button"
                    onClick={() => DeleteRowInWorkshopDetails(index)}
                  >
                    <i className="fa-solid fa-trash"></i>
                  </span>
                  <div
                    className="input-containerEffect mt-1"
                    id="PartyInput"
                    style={{ margin: "1%", width: "100%" }}
                  >
                    <select
                      className="form-control inputEffect modify_im_input mode_limit mode_category input-s1"
                      required
                      style={{ fontSize: "14px", padding: "0 10px" }}
                      onChange={(e) => handleInputChange(e, index)}
                      value={Item.workshopName}
                      name="workshopName"
                    >
                      {companies.length > 0 &&
                        companies.map((company, index) => (
                          <option key={index} value={company.id}>
                            {company.name}
                          </option>
                        ))}
                    </select>
                    <label id="input1" className="labelEffect1">
                      Workshop Name
                    </label>
                  </div>
                  <div
                    className="input-containerEffect mt-1"
                    id="PartyInput"
                    style={{ margin: "1%", width: "100%" }}
                  >
                    <input
                      className="form-control inputEffect modify_im_input mode_limit mode_category input-s1"
                      style={{}}
                      type="text"
                      required
                      onChange={(e) => handleInputChange(e, index)}
                      value={Item.orderNo}
                      name="orderNo"
                    />
                    <label id="input1" className="labelEffect1">
                      Order No.
                    </label>
                  </div>
                </div>
                <div className="space-between mt-1">
                  <div
                    className="input-containerEffect mt-1"
                    id="PartyInput"
                    style={{ margin: "1%", width: "100%" }}
                  >
                    <input
                      className="form-control inputEffect modify_im_input mode_limit mode_category input-s1"
                      style={{}}
                      type="text"
                      required
                      onChange={(e) => handleInputChange(e, index)}
                      value={Item.partyName}
                      name="partyName"
                    />
                    <label id="input1" className="labelEffect1">
                      Party Name
                    </label>
                  </div>
                </div>

                <div className="space-between mt-1">
                  <div
                    className="input-containerEffect mt-1"
                    id="PartyInput"
                    style={{ margin: "1%", width: "100%" }}
                  >
                    <input
                      className="form-control inputEffect modify_im_input mode_limit mode_category input-s1"
                      style={{}}
                      type="text"
                      required
                      onChange={(e) => handleInputChange(e, index)}
                      value={Item.rItemName}
                      name="rItemName"
                    />
                    <label id="input1" className="labelEffect1">
                      Right Item Name
                    </label>
                  </div>
                  <div
                    className="input-containerEffect mt-1"
                    id="PartyInput"
                    style={{ margin: "1%", width: "100%" }}
                  >
                    <input
                      className="form-control inputEffect modify_im_input mode_limit mode_category input-s1"
                      style={{}}
                      type="text"
                      required
                      onChange={(e) => handleInputChange(e, index)}
                      value={Item.lItemName}
                      name="lItemName"
                    />
                    <label id="input1" className="labelEffect1">
                      Left Item Name
                    </label>
                  </div>
                </div>

                <div className="" style={{}}>
                  <div className="input-box-SI-2">
                    <div className="input-box-m6">
                      <div
                        className="row mt-2"
                        style={{ width: "96%", margin: "auto" }}
                      >
                        <label className="col-sm-3"></label>
                        <label
                          className="col-sm1-4 fs-131"
                          style={{ width: "15%", textAlign: "center" }}
                        >
                          SPH
                        </label>
                        <label
                          className="col-sm1-4 fs-131"
                          style={{ width: "15%", textAlign: "center" }}
                        >
                          CYL
                        </label>
                        <label
                          className="col-sm1-4 fs-131"
                          style={{ width: "15%", textAlign: "center" }}
                        >
                          AXIS
                        </label>
                        <label
                          className="col-sm1-4 fs-131"
                          style={{ width: "15%", textAlign: "center" }}
                        >
                          V/N
                        </label>
                        <label
                          className="col-sm1-4 fs-131"
                          style={{ width: "15%", textAlign: "center" }}
                        >
                          Add
                        </label>
                        <label
                          className="col-sm1-4 fs-131"
                          style={{ width: "15%", textAlign: "center" }}
                        >
                          PD
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="input-box-SI-2" style={{ width: "100%" }}>
                    <div className="input-box-m6">
                      <div
                        className="row mt-2"
                        style={{ width: "96%", margin: "auto" }}
                      >
                        <label
                          className="col-sm-3 fs-131"
                          style={{ padding: "4px" }}
                        >
                          {" "}
                          Right &nbsp;
                        </label>
                        <input
                          className="pwrInput col-sm1-3 table-input box-size1"
                          style={{ width: "13%" }}
                          type="text"
                          required
                          onChange={(e) => handleInputChange(e, index)}
                          value={Item.spH_R}
                          name="spH_R"
                        />
                        <input
                          className="pwrInput col-sm1-3 table-input box-size1"
                          style={{ width: "13%" }}
                          type="text"
                          required
                          onChange={(e) => handleInputChange(e, index)}
                          value={Item.cyL_R}
                          name="cyL_R"
                        />
                        <input
                          className="pwrInput col-sm1-3 table-input box-size1"
                          style={{ width: "13%" }}
                          type="text"
                          required
                          onChange={(e) => handleInputChange(e, index)}
                          value={Item.axiS_R}
                          name="axiS_R"
                        />
                        <input
                          className="pwrInput col-sm1-3 table-input box-size1"
                          style={{ width: "13%" }}
                          type="text"
                          onChange={(e) => handleInputChange(e, index)}
                          value={Item.v_N_R}
                          name="v_N_R"
                          required
                        />
                        <input
                          className="pwrInput col-sm1-3 table-input box-size1"
                          style={{ width: "13%" }}
                          type="text"
                          onChange={(e) => handleInputChange(e, index)}
                          value={Item.adD_R}
                          name="adD_R"
                          required
                        />
                        <input
                          className="pwrInput col-sm1-3 table-input box-size1"
                          style={{ width: "13%" }}
                          type="text"
                          required
                          onChange={(e) => handleInputChange(e, index)}
                          value={Item.pD_R}
                          name="pD_R"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="input-box-SI-2">
                    <div className="input-box-m6">
                      <div
                        className="row mt-2"
                        style={{ width: "96%", margin: "auto" }}
                      >
                        <label
                          className="col-sm-3 fs-131"
                          style={{ padding: "4px" }}
                        >
                          {" "}
                          Left &nbsp;
                        </label>
                        <input
                          className="pwrInput col-sm1-4 table-input box-size1"
                          style={{ width: "13%" }}
                          type="text"
                          required
                          onChange={(e) => handleInputChange(e, index)}
                          value={Item.spH_L}
                          name="spH_L"
                        />
                        <input
                          className="pwrInput col-sm1-4 table-input box-size1"
                          style={{ width: "13%" }}
                          type="text"
                          required
                          onChange={(e) => handleInputChange(e, index)}
                          value={Item.cyL_L}
                          name="cyL_L"
                        />
                        <input
                          className="pwrInput col-sm1-4 table-input box-size1"
                          style={{ width: "13%" }}
                          type="text"
                          required
                          onChange={(e) => handleInputChange(e, index)}
                          value={Item.axiS_L}
                          name="axiS_L"
                        />
                        <input
                          className="pwrInput col-sm1-4 table-input box-size1"
                          style={{ width: "13%" }}
                          type="text"
                          required
                          onChange={(e) => handleInputChange(e, index)}
                          value={Item.v_N_L}
                          name="v_N_L"
                        />
                        <input
                          className="pwrInput col-sm1-4 table-input box-size1"
                          style={{ width: "13%" }}
                          type="text"
                          required
                          onChange={(e) => handleInputChange(e, index)}
                          value={Item.adD_L}
                          name="adD_L"
                        />
                        <input
                          className="pwrInput col-sm1-4 table-input box-size1"
                          style={{ width: "13%" }}
                          type="text"
                          required
                          onChange={(e) => handleInputChange(e, index)}
                          value={Item.pD_L}
                          name="pD_L"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="labelFieldGrid mt-3"
                  style={{ justifyContent: "initial" }}
                >
                  {Item.lensDetail &&
                    Item.lensDetail.length > 0 &&
                    Item.lensDetail.map((items, idx) => (
                      <div
                        key={idx}
                        className="input-containerEffect mt-2"
                        style={{ margin: "1%" }}
                      >
                        <input
                          className="form-control inputEffect modify_im_input mode_limit mode_category input-s1"
                          type="text"
                          style={{ width: "98%" }}
                          required
                          onChange={(e) =>
                            handleExtrafieldChange(e, idx, index)
                          }
                          value={items.ef1 || ""}
                          name={items.optionalFieldName}
                        />
                        <label className="labelEffect1">
                          {items.optionalFieldName}
                        </label>
                      </div>
                    ))}

                  {/* <div
                    className="input-containerEffect mt-2"
                    style={{ margin: "1%" }}
                  >
                    <input
                      className="form-control inputEffect modify_im_input mode_limit mode_category input-s1"
                      type="text"
                      style={{ width: "98%" }}
                      required
                      onChange={(e) => handleInputChange(e, index)}
                      value={Item.customerCard}
                      name="customerCard"
                    />
                    <label id="input1" className="labelEffect1">
                      Customer Card
                    </label>
                  </div> */}

                  {/* <div
                    className="input-containerEffect mt-2"
                    style={{ margin: "1%" }}
                  >
                    <input
                      className="form-control inputEffect modify_im_input mode_limit mode_category input-s1"
                      type="text"
                      style={{ width: "98%" }}
                      required
                      onChange={(e) => handleInputChange(e, index)}
                      value={Item.dia}
                      name="dia"
                    />
                    <label id="input1" className="labelEffect1">
                      DIA
                    </label>
                  </div> */}

                  {/* <div
                    className="input-containerEffect mt-2"
                    style={{ margin: "1%" }}
                  >
                    <input
                      className="form-control inputEffect modify_im_input mode_limit mode_category input-s1"
                      type="text"
                      style={{ width: "98%" }}
                      required
                      onChange={(e) => handleInputChange(e, index)}
                      value={Item.fittingHeight}
                      name="fittingHeight"
                    />
                    <label id="input1" className="labelEffect1">
                      Fitting Height
                    </label>
                  </div> */}

                  {/* <div
                    className="input-containerEffect mt-2"
                    style={{ margin: "1%" }}
                  >
                    <input
                      className="form-control inputEffect modify_im_input mode_limit mode_category input-s1"
                      type="text"
                      style={{ width: "98%" }}
                      required
                      onChange={(e) => handleInputChange(e, index)}
                      value={Item.fittingType}
                      name="fittingType"
                    />
                    <label id="input1" className="labelEffect1">
                      Fitting Type
                    </label>
                  </div> */}

                  {/* <div
                    className="input-containerEffect mt-2"
                    style={{ margin: "1%" }}
                  >
                    <input
                      className="form-control inputEffect modify_im_input mode_limit mode_category input-s1"
                      type="text"
                      style={{ width: "98%" }}
                      required
                      onChange={(e) => handleInputChange(e, index)}
                      value={Item.diM_R}
                      name="diM_R"
                    />
                    <label id="input1" className="labelEffect1">
                      DiM_R
                    </label>
                  </div> */}

                  {/* <div
                    className="input-containerEffect mt-2"
                    style={{ margin: "1%" }}
                  >
                    <input
                      className="form-control inputEffect modify_im_input mode_limit mode_category input-s1"
                      type="text"
                      style={{ width: "98%" }}
                      required
                      onChange={(e) => handleInputChange(e, index)}
                      value={Item.diM_L}
                      name="diM_L"
                    />
                    <label id="input1" className="labelEffect1">
                      DiM_L
                    </label>
                  </div> */}

                  {/* <div
                    className="input-containerEffect mt-2"
                    style={{ margin: "1%" }}
                  >
                    <input
                      className="form-control inputEffect modify_im_input mode_limit mode_category input-s1"
                      type="text"
                      style={{ width: "98%" }}
                      required
                      onChange={(e) => handleInputChange(e, index)}
                      value={Item.base}
                      name="base"
                    />
                    <label id="input1" className="labelEffect1">
                      Base
                    </label>
                  </div> */}

                  {/* <div
                    className="input-containerEffect mt-2"
                    style={{ margin: "1%" }}
                  >
                    <input
                      className="form-control inputEffect modify_im_input mode_limit mode_category input-s1"
                      type="text"
                      style={{ width: "98%" }}
                      required
                      onChange={(e) => handleInputChange(e, index)}
                      value={Item.prismRemarks}
                      name="prismRemarks"
                    />
                    <label id="input1" className="labelEffect1">
                      Prism Remarks
                    </label>
                  </div> */}

                  {/* <div
                    className="input-containerEffect mt-2"
                    style={{ margin: "1%" }}
                  >
                    <input
                      className="form-control inputEffect modify_im_input mode_limit mode_category input-s1"
                      type="text"
                      style={{ width: "98%" }}
                      required
                      onChange={(e) => handleInputChange(e, index)}
                      value={Item.tint}
                      name="tint"
                    />
                    <label id="input1" className="labelEffect1">
                      Tint
                    </label>
                  </div> */}

                  {/* <div
                    className="input-containerEffect mt-2"
                    style={{ margin: "1%" }}
                  >
                    <input
                      className="form-control inputEffect modify_im_input mode_limit mode_category input-s1"
                      type="text"
                      style={{ width: "98%" }}
                      required
                      onChange={(e) => handleInputChange(e, index)}
                      value={Item.fitting}
                      name="fitting"
                    />
                    <label id="input1" className="labelEffect1">
                      Fitting
                    </label>
                  </div> */}

                  {/* <div
                    className="input-containerEffect mt-2"
                    style={{ margin: "1%" }}
                  >
                    <input
                      className="form-control inputEffect modify_im_input mode_limit mode_category input-s1"
                      type="text"
                      style={{ width: "98%" }}
                      required
                      onChange={(e) => handleInputChange(e, index)}
                      value={Item.mirror}
                      name="mirror"
                    />
                    <label id="input1" className="labelEffect1">
                      Mirror
                    </label>
                  </div> */}
                  {/* 
                  <div
                    className="input-containerEffect mt-2"
                    style={{ margin: "1%" }}
                  >
                    <input
                      className="form-control inputEffect modify_im_input mode_limit mode_category input-s1"
                      type="text"
                      style={{ width: "98%" }}
                      required
                      onChange={(e) => handleInputChange(e, index)}
                      value={Item.remarks}
                      name="remarks"
                    />
                    <label id="input1" className="labelEffect1">
                      {" "}
                      Remarks
                    </label>
                  </div> */}

                  {/* <div
                    className="input-containerEffect mt-2"
                    style={{ margin: "1%" }}
                  >
                    <input
                      id="withFrame"
                      className="form-control inputEffect modify_im_input mode_limit mode_category input-s1"
                      type="text"
                      onChange={() => WithFrameChange()}
                      required
                      // onChange={(e) => handleInputChange(e , index)}
                      value={Item.withFrame}
                      name="withFrame"
                    />
                    <label id="input1" className="labelEffect1">
                      With Frame (Y/N)
                    </label>
                  </div> */}
                  {/* <div
                    id=""
                    className="input-containerEffect mt-2"
                    style={{ margin: "1%" }}
                  >
                    <input
                      className="form-control inputEffect modify_im_input mode_limit mode_category input-s1"
                      placeholder="Lens Name"
                      type="text"
                      style={{ width: "98%" }}
                      required
                      onChange={(e) => handleInputChange(e, index)}
                      value={Item.lensOnly}
                      name="lensOnly"
                    />
                    <label id="input1" className="labelEffect1">
                      Lens Only
                    </label>

                  </div> */}
                </div>
                {/* <div
                  id="FrameName"
                  className="input-containerEffect mt-2"
                  style={{ margin: "1%", display: "none", width: "50%" }}
                >
                  <input
                    className="form-control inputEffect modify_im_input mode_limit mode_category input-s1"
                    type="text"
                    required
                    onChange={(e) => handleInputChange(e, index)}
                    value={Item.workshopName}
                    name="workshopName"
                  />
                  <label id="input1" className="labelEffect1">
                    Frame Name
                  </label>
                </div> */}
              </div>
            ))}
            {/* <button className="ws-addrowbtn" onClick={AddRowInWorkshopDetails}>
              Add Row{" "}
            </button> */}
          </div>

          {/**************************************************/}
          <div
            className="flex-end"
            style={{
              padding: "0px",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div className="ws-generate">
              <button onClick={() => CreateTransaction("Purchase")}>
                Generate P/O
              </button>
              <button onClick={() => CreateTransaction("sale")}>
                Generate S/O
              </button>
            </div>
            <div>
              <AutoSuggestionBox
                SuggestionList={filteredItems}
                ShowSuggestionBox={isDropdownOpen1}
                handleSelection={handleDataSelection}
                DivClassName="input-containerEffect mt-1"
                InputClassName="form-control inputEffect modify_im_input mode_limit mode_category input-s1"
                handleKeyPress={() => {
                  return;
                }}
                Ref={null}
                NextRef={null}
                InputId={""}
                Name="op3"
                inputOnChangeFunction={(e) => handleInputChangeAuto(e, 2)}
                InputLabel="Vendor Name"
                AddNewButtonAllow={false}
                ShowName={workshopDetails[0].op2}
                SuggestionClass={"ItemmasterDuggestionsaleinvoiceSuggestion"}
              />
            </div>
            <div
              style={{
                width: "60%",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <button
                className="greenBtn"
                style={{ width: "40%" }}
                onClick={() => SaveAndUpdateWorkshopData()}
              >
                Save
              </button>
              <button
                className="redBtn"
                style={{ width: "40%" }}
                onClick={closeWorkshopModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkshopModalLens;
